import React, { useEffect, useState } from "react"
import "./styles.scss"

const AccordionOld = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0)
  const handleTab = tab => {
    setActiveTab(tab)
  }
  return (
    <div className="accordionOld">
      {tabs.map((tab, i) => {
        return (
          <div
            key={i}
            onClick={() => {
              handleTab(i)
            }}
            className={`accordionOld__element ${i !== activeTab ? "" : "active"}`}
          >
            <h5 className="accordionOld__title">{tab.name || tab.title}</h5>
            <p className="accordionOld__description">{tab.description}</p>
          </div>
        )
      })}
    </div>
  )
}

export default AccordionOld
